// The firmware version number is encoded inside the first 44 bytes of the file.
// It lives as ASCII text on byte positions 32-35 and may be padded with 0x00 bytes.
const FIRMWARE_HEADER_BYTES_TO_READ = 44;
const VERSION_NUMBER_START_INDEX = 32;
const VERSION_NUMBER_END_INDEX = 36; // exclusive, so bytes 32, 33, 34, 35

// Reads the version number that the firmware file declares in its header.
// Leading/trailing 0x00 padding (and whitespace) is trimmed away.
export async function readVersionNumberFromFile(file: File): Promise<string> {
  const firmwareHeader = await file.slice(0, FIRMWARE_HEADER_BYTES_TO_READ).arrayBuffer();
  const headerBytes = new Uint8Array(firmwareHeader);
  const versionNumberBytes = headerBytes.slice(VERSION_NUMBER_START_INDEX, VERSION_NUMBER_END_INDEX);
  const decodedVersionNumber = new TextDecoder('ascii').decode(versionNumberBytes);

  return decodedVersionNumber.replace(/\0/g, '').trim();
}
